import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=1128bb6b&scoped=true&"
import script from "./AboutUs.vue?vue&type=script&lang=js&"
export * from "./AboutUs.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=1128bb6b&scoped=true&lang=css&"
import style1 from "./AboutUs.vue?vue&type=style&index=1&id=1128bb6b&lang=less&scoped=true&"
import style2 from "./AboutUs.vue?vue&type=style&index=2&id=1128bb6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1128bb6b",
  null
  
)

export default component.exports